import { useEffect, useState } from "react";
import { subscribeCareSourceById } from "../../../features/careSourceProcessing/careSourceLookupService";
import { getSourceNoteId } from "../utils/sourceCaptureReceipt";
const isStaffSource = (record = {}) =>
  Boolean(
    record.staffOriginalVersion ||
    record.staffSignatureId ||
    record.metadata?.staffOriginalVersion ||
    record.sourceMetadata?.staffSigningEnabled,
  );

// A staff version identifies the workflow, not a signature. Resolve even marked
// rows so unsigned originals can use their existing versioned edit workflow.
export default function useStaffOriginalProtection(entry, childId) {
  const sourceId = getSourceNoteId(entry),
    marked = isStaffSource(entry);
  const signed = Boolean(entry.staffSignatureId);
  const [resolved, setResolved] = useState(null);
  useEffect(() => {
    if (signed || !sourceId) {
      setResolved(null);
      return undefined;
    }
    let active = true;
    const update = (source) => {
      if (active) setResolved({ sourceId, childId, source });
    };
    const failed = () => {
      if (active) setResolved({ sourceId, childId, failed: true });
    };
    let unsubscribe;
    try {
      unsubscribe = subscribeCareSourceById(sourceId, update, failed);
    } catch {
      failed();
    }
    return () => {
      active = false;
      unsubscribe?.();
    };
  }, [signed, sourceId, childId]);
  if (signed) return { sourceId, staff: true, signed: true, blocked: true };
  if (!sourceId)
    return { sourceId, staff: marked, signed: false, blocked: marked };
  if (
    !resolved ||
    resolved.sourceId !== sourceId ||
    resolved.childId !== childId ||
    resolved.failed
  )
    return { sourceId, staff: marked, signed: false, blocked: true };
  const source = resolved.source;
  return {
    sourceId,
    source,
    staff: marked || isStaffSource(source || {}),
    signed: Boolean(source?.staffSignatureId),
    blocked: Boolean(
      (source && childId && source.childId !== childId) ||
      source?.staffSignatureId ||
      source?.status === "deleted" ||
      source?.sourceLifecycle?.state === "withdrawn" ||
      (marked && !source),
    ),
  };
}
